import { render } from "./CreditLucky.vue?vue&type=template&id=c6c45ff8&scoped=true"
import script from "./CreditLucky.vue?vue&type=script&lang=js"
export * from "./CreditLucky.vue?vue&type=script&lang=js"

import "./CreditLucky.vue?vue&type=style&index=0&id=c6c45ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c45ff8"]])

export default __exports__